module.exports = __webpack_public_path__ + "img/pass2.5b383379.svg";